import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles, Checkbox } from '@material-ui/core';
import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  overflow: auto;
  /* max-height: 400px; */
  /* height: 100%; */
  position: relative;
  background-color: #ffffff;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
`
export const TableFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /* height: 5em; */
  width: 100%;
  padding: 1em 2em 1em 1em;
  flex-wrap: wrap;
  box-shadow: 0px 0px 1px rgba(68, 68, 68, 0.12), 0px -1px 2px rgba(68, 68, 68, 0.16);
  background-color: #FFFF;
  transform: scale(1.00000001);
  @media screen and (max-width: 425px) {
    /* flex-direction: column; */
    height: auto;
    padding: .5em .5em;
    & div {
      &:nth-child(1){
        margin-bottom: .5em
      };
      &:nth-child(2){
        margin-bottom: .5em;
        margin: 0 auto .2em auto;
      }
    }
  }
`
export const TotalElementCont = styled.div`
  display: flex;
  flex-direction: row;
  & > span.listitems-txt{
    font-family: Open sans;
    font-style: normal;
    font-size: 13px;
    line-height: 18px;
    /* identical to box height */
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    /* Textos / Terciario */
    color: #6A6A6A;
    &:first-child{
      font-family: Open Sans;
      font-weight: 500;
      /* margin-right: .5em; */
    }
  }
`
export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #F8F8F8;
  padding: 8px 10px;
  border-radius: 40px;
`
export const DoubleArrowImg = styled.img`
  width: 1.5em;
  height: auto;
  cursor: pointer;
  margin: 0 .2em;
`
export const ArrowContainer = styled.div`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px;
  width: 24px;
  height: 24px;
  /* Ripley / Morado */
  background: #5E388A;
  border-radius: 28px;
  margin: 0 .2em;
  cursor: pointer;
`
export const PageNumbers = styled.div`
  display: flex;
  align-items: center;
`
export const NumberPage = styled.span`
  font-family: Open Sans;
  font-weight: ${ ({ active }) => active ? 500 : 'normal'};
  margin: 0 .7em;
  cursor: pointer;
`
export const ShowElementCont = styled.div`
  display: flex;
  flex-direction: row;
  & span{
    font-family: Open Sans;
    font-style: normal;
    font-size: 13px;
    line-height: 18px;
    /* identical to box height */
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    /* Textos / Terciario */
    color: #A0A2A6;
  }
`
export const useInputStyles = makeStyles(theme => ({
  root: {
    minWidth: '1.8em',
    maxWidth: '2.2em',
    height: '2em',
    margin: '0 .5em',
    '@media screen and (max-width: 425px)':{
      marginBottom: '0 !important',
    },
    '& input': {
      padding: '8px 4px 4px',
      textAlign: 'center',
      fontSize: '12px',
      lineHeight: '16px',
      color: '#6A6A6A'
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: '#dcdcdc',
      '&$focused': {
        borderColor: 'red'
      }
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: '#5E388A',
      borderWidth: '.5px'
    }
  },
  focused: {}
}));
export const PurpleCheckbox = withStyles({
  root: {
    color: '#CFD4D8',
    '&$checked': {
      color: '#5E388A',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);
